import {combineReducers} from 'redux'
import types from 'actions/types'

const open = (state = false, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_PURCHASE_INVOICE_ITEM_DRAWER:
      return true
    case types.PURCHASING_HIDE_PURCHASE_INVOICE_ITEM_DRAWER:
      return false
    case types.PURCHASING_LOAD_PURCHASE_ORDER_ATTEMPT:
      return false
    default:
      return state
  }
}

const purchaseInvoiceItem = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_SHOW_PURCHASE_INVOICE_ITEM_DRAWER:
      return action.purchaseInvoiceItem
    case types.PURCHASING_HIDE_PURCHASE_INVOICE_ITEM_DRAWER:
      return null
    default:
      return state
  }
}

export default combineReducers({
  open,
  purchaseInvoiceItem,
})
